import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Store} from "@ngrx/store";
import {
  createSavedReportsFolder,
  createSavedReportsFolderSuccess,
  updateSavedReportsFolder,
  updateSavedReportsFolderSuccess
} from '../../../shared/store/savedReportsFolders/savedReportsFolders.actions';
import {DialogFormStore} from '../../../shared/store/dialog/dialogForm.store';
import {BehaviorSubject, Observable} from 'rxjs';

@Component({
  selector: 'app-folder-form',
  templateUrl: './folder-form.component.html',
  styleUrls: ['./folder-form.component.scss'],
  providers: [
    DialogFormStore
  ]
})
export class FolderFormComponent implements OnInit, AfterViewInit {
  public form: FormGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    parent_folder_id: new FormControl(null)
  });

  public readonly loading$: Observable<boolean> = this._dialogFormStore.loading$;
  public readonly folderTitle$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public readonly folderName$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public readonly submitButtonText$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public readonly folderIdToMove$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    public readonly dialogRef: MatDialogRef<FolderFormComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private readonly _store: Store,
    private readonly _dialogFormStore: DialogFormStore,
  ) {}

  ngOnInit(): void {
    this._dialogFormStore.init(
      this.form,
      this.dialogRef,
      [createSavedReportsFolder, updateSavedReportsFolder],
      [createSavedReportsFolderSuccess, updateSavedReportsFolderSuccess],
      []
    );
  }

  ngAfterViewInit(): void {
    this._fillFormData();
  }

  public onCreate(): void {
    if (this.data.folder !== undefined) {
      this._store.dispatch(updateSavedReportsFolder({savedReportFolder: this.data.folder.payload, update: this.form.value}));
    } else {
      this._store.dispatch(createSavedReportsFolder(this.form.value));
    }
  }

  private _fillFormData(): void {
    if (this.data.folder !== undefined) {
      this.form.get('name').setValue(this.data.folder.payload.attributes.name);
      this.form.get('parent_folder_id').setValue(this.data.folder.payload.attributes.parent_folder_id);

      this.folderName$.next(this.data.folder.getFullPathToStr());
      this.folderTitle$.next('folders.update_folder');
      this.submitButtonText$.next('button.update');
      this.folderIdToMove$.next(this.data.folder.payload.id);
    } else if (this.data.parent !== undefined) {
      this.form.get('parent_folder_id').setValue(this.data.parent.payload.id || null);

      this.folderName$.next(this.data.parent.getFullPathToStr());
      this.folderTitle$.next('folders.create_folder');
      this.submitButtonText$.next('button.create');
    }
  }
}
